export const hourlyWeatherForecastIDS = {
  headerText: 'hourly_weather_forecast_tile_header_text',
  firstHour: 'hourly_weather_forecast_tile_hour_1',
  secondHour: 'hourly_weather_forecast_tile_hour_2',
  thirdHour: 'hourly_weather_forecast_tile_hour_3',
};
